import * as ShopsApi from "src/core/api/shops";

export async function getShopFullSettings(axiosInstance) {
  return await ShopsApi.fullSettings(axiosInstance);
}
